export const REDO_API_URL = process.env.REDO_API_URL || "http://localhost:8004";
